import { PropsWithChildren } from 'react';
import MuiXLicense from 'core/services/mui/MuiXLicense';
import { ThemeProvider } from 'theme/ThemeProvider';
import { ApolloClientProvider } from 'core/services/apollo/ApolloClientProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RecoilRoot } from 'recoil';
import {
  PendoProviderWrapper,
  PostHogProviderWrapper
} from 'services/tracking';
import { registerAgGridModules } from 'core/services/agGrid/agGridModules';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false
    }
  }
});

registerAgGridModules();

export const AppProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <PostHogProviderWrapper>
      <PendoProviderWrapper>
        <RecoilRoot>
          <ThemeProvider>
            <MuiXLicense />
            <ApolloClientProvider>
              <QueryClientProvider client={queryClient}>
                {children}
              </QueryClientProvider>
            </ApolloClientProvider>
          </ThemeProvider>
        </RecoilRoot>
      </PendoProviderWrapper>
    </PostHogProviderWrapper>
  );
};
